export const theme = {
  app_title: "Angus Live",
  favicon_url: "assets/brand/logo_green.svg",
  favicon_url_dark_mode: "assets/brand/logo_green.svg",
  header_logo_large_url: "assets/brand/logo.svg",
  header_logo_large_url_alt: "Angus Live Logo",
  header_logo_small_url: "assets/brand/logo_white.svg",
  main_banner_url_srcset: [
    "assets/images/header/ALG2Home_Header_XL_2450.png 2450w",
    "assets/images/header/ALG2Home_Header_L_1200.png 1199w",
    "assets/images/header/ALG2Home_Header_M_992.png 992w",
    "assets/images/header/ALG2Home_Header_S_768.png 771w",
    "assets/images/header/ALG2Home_Header_XS_576.png 577w"
  ],
  main_banner_url: "assets/images/header/ALG2Home_Header_M_992.png",
  auction_listing_banner_url_srcset: [
    "assets/images/header/header_xl.png 2450w",
    "assets/images/header/header_l.png 1199w",
    "assets/images/header/header_m_992.png 992w",
    "assets/images/header/header_s_768.png 771w",
    "assets/images/header/header_xs_576.png 577w"
  ],
  auction_listing_banner_url: "assets/images/header/header_xl.png",
  header_menu: [
    {
      title: "Auctions",
      router_link: ["/auctions"],
      menu_items: []
    },
    {
      title: "Sellers",
      router_link: ["/sellers"],
      menu_items: [
        {
          title: "Seller Portal",
          router_link: ['/sellers', 'seller-portal'],
          required_roles: ['SELLER']
        },
        {
          title: "Marketing and Sales on Angus Live",
          router_link: ['/sellers'],
          fragment: "seller-info"
        },
        {
          title: "Services",
          router_link: ['/sellers'],
          fragment: "seller-services"
        },
        {
          title: "Terms and Conditions",
          router_link: ['/sellers'],
          fragment: "terms-and-conditions"
        }
      ]
    },
    {
      title: "Buyers",
      router_link: ["/buyers"],
      menu_items: [
        {
          title: "Bidding Portal",
          router_link: ['/buyers', 'bidding-portal'],
          required_roles: ['SELLER']
        },
        {
          title: "Buying on Angus Live",
          router_link: ['/buyers']
        },
        {
          title: "Delivery & Payment",
          router_link: ['/buyers'],
          fragment: "delivery-payment"
        },
        {
          title: "Service Providers",
          router_link: ['/buyers'],
          fragment: "service-providers"
        },
        {
          title: "Terms and Conditions",
          router_link: ['/buyers'],
          fragment: "Terms & Conditions"
        }
      ]
    },
    {
      title: "Community",
      router_link: ["/community"],
      menu_items: []
    },
  ],
  sales_office_phone_number: "(406) 571-3006",
  sales_office_email_address: "sales@anguslive.com",
  marketing_phone_number: "(406) 571-3006",
  marketing_email_address: "marketing@anguslive.com",
  support_email_address: "support@anguslive.com",
  facebook_url: "https://www.facebook.com/AngusLiveAuction",
  instagram_url: "https://www.instagram.com/angusliveg2/",
  twitter_url: "https://twitter.com/live_angus",
  youtube_url: "https://www.youtube.com/channel/UCZUxDN5gyn_MGwfG3CBupVg/featured",
  use_wagyu_epd_terminology: false,
  epd_section_label: "EPDs",
  epd_actual_label: "Actual EPDs",
  epd_projected_label: "Projected EPDs",
  epd_category_labels: {
    production: "Production EPDs",
    maternal: "Maternal EPDs",
    management: "Management EPDs",
    weight: "Weight",
    fertility: "Fertility/Calving",
    carcass: "Carcass EPDs",
    dollarValues: "$Values Index"
  }
}